<template>
  <div class="home-box">
    <PageTitle :title="pageTitle" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <SupplierCreateForm :formData="formData" :mode="mode" :id="id" :proploading="loading"></SupplierCreateForm>
      </div>
    </v-row>
  </div>
</template>
  
  <script>
  import SupplierCreateForm from "@/components/suppliers/SupplierCreateForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  import { SupplierService } from "@/services/supplier-service.js";
  
  export default {
    name: "SupplierCreate",
    components: {
      SupplierCreateForm,
      PageTitle,
    },
    props: {
    mode: { type: String, required: true },
    id: { type: String, default: null },
  },

  data: function () {
    return {
      formData: {
        name: "",
        supplier_category_id: "",
        supplier_code: '',
        contact_person: "",
        phone: "",
        mobile: "",
        email: "",
        address: "",
        country_id: "",
        city: "",
        company_reg_no: "",
        vat_reg_no: "",
        nbt_reg_no: "",
        credit_limit: "",
        credit_period_days: '',
        status: 'ACTIVE',
        remarks: "",
        profile_image : null,
      },
      loading: false,
      errors : null,
    };
  },
    computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    pageTitle() {
      return this.mode === "edit" ? "Update Supplier" : "Create Supplier";
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
    if (this.mode === "edit") {
      this.fetchSupplier();
    }
  },

  methods: {
    async fetchSupplier() {
      if(!this.id) return;
      try {
        this.loading = true;
        const supplier = await SupplierService.fetchSupplierDetails(this.id);
        this.formData = supplier.data;
      } catch (error) {
        console.error(error);
        this.errors = error.message;
      } finally{
        this.loading = false;
      }
    },   
  },
  
  };
  </script>
  